// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`BoostModule general snapshot 1`] = `
<div class="boost-module">
  <div class="boost-module-wrap" name="height">
    <!---->
    <div class="boost-module-cta xs-12">
      <div class="boost-intro xs-12 text-center">
        <p class="xs-f-medium lg-f-xmedium max-at-tweak">Want undefined?—add a Pro&nbsp;Boost</p>
      </div>
      <div class="boost-product-info xs-12"><button class="btn-reset checkbox-wrap full-width">
          <div class="mr-checkbox"></div><span class="ada-tooltip">add to bag</span><img src="www.url" alt="" class="boost-image">
          <div class="boost-info"><span class="boost-name upper xs-f-xsmall max-at-tweak">Boost 1</span><span class="boost-price bold xs-f-small lg-f-medium max-at-tweak">$NaN</span></div>
        </button></div>
      <div class="boost-ctas xs-12"><button class="btn-reset pull-left color-purple xs-f-small max-at-tweak">More boosts</button><button class="btn-reset pull-right color-purple xs-f-small max-at-tweak">What's a boost?</button></div>
    </div>
  </div>
</div>
`;
